<template>
    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="提交时间" name="companyName">
                    <range-picker v-model:startDate="searchForm.startDate" v-model:endDate="searchForm.endDate"/>
            </a-form-item>

            <a-form-item label="申请进度" name="schedule">
                <a-select v-model:value="searchForm.schedule" placeholder="请选择审核状态">
                    <a-select-option value="0">申请中</a-select-option>
                    <a-select-option value="1">通过</a-select-option>
                    <a-select-option value="2">不通过</a-select-option>
                    <a-select-option value="3">印章刻制中</a-select-option>
                    <a-select-option value="4">印章刻制完成</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <div class="table-toolbar">
            <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined/>
                </template>
                新增
            </a-button>
            <!-- <a-button @click="exportExcelTemplate0">
                刻章刻制流转单模板
            </a-button> -->
            <a-button @click="exportExcelTemplate1">
                刻章备案登记表模板
            </a-button>
            <!-- <a-button @click="exportExcelTemplate2">
                刻章委托书模板
            </a-button> -->
            <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)" v-if="selectedRowKeys.length">
                <a-button danger>批量删除</a-button>
            </a-popconfirm>
        </div>
        <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert>
        <a-table
            :columns="columns"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <template #companyName="{record}">
                <a @click="onDetail(record)">{{record.companyName}}</a>
            </template>
            <template #schedule="{record}">
                <span style="color:#0059B5;background: #e5eef7;padding: 6px 15px;border-radius: 4px;" v-if="record.schedule==0">申请中</span>
                <!-- <span style="color:red" v-if="record.schedule==1">未通过</span> -->
                <a-popover v-if="record.schedule==1" placement="bottom">
                    <template #content v-if="record.remark">
                      <p>{{record.remark}}</p>
                    </template>
                    <template #title>
                      <span>未通过原因</span>
                    </template>
                    <a style="color:#DD0F31;background: #fce7ea;padding: 6px 15px;border-radius: 4px;">未通过</a>
                  </a-popover>
                <span style="color:#00B51A;background: #e5f7e8;padding: 6px 15px;border-radius: 4px;" v-if="record.schedule==2">已通过</span>
                <span style="color:gold" v-if="record.schedule==3">印章刻制中</span>
                <span style="color:#87d068" v-if="record.schedule==4">印章刻制完成</span>
            </template>
            <template #collectionMethod="{record}">
                <span v-if="record.collectionMethod==0">自取</span>
                <span v-if="record.collectionMethod==1">邮寄</span>
            </template>
            <template #submitTime="{record}">
               <span :class="{clred:!record.submitTime}">{{record.submitTime? record.submitTime.split(' ')[0] : '未提交'}}</span>
            </template>
            <template #action="{record}">
                <a @click="onDetail(record)" style="color: #00B51A;">详情 </a>
                <a v-if="record.isSubmit==0" @click="onEdit(record)" style="color: #0059B5;"> 编辑</a>
                <a v-if="record.isSubmit==0" @click="onSubmit(record)" style="color: #2b8aa6;"> 提交</a>
            </template>
        </a-table>
    </a-card>
    <Detail ref="detailmodal" :form-primary-key-field="listKeyField" @finish="onFormEdited" @onCloseModel="onCloseModel"/>
</template>

<script>
import { file_service } from "@/api/adminService";
import { companyInfo } from '@/api/companyService';
// import Detail from "./components/Detail";
import Detail from "./components/DetailModal";
import {tableListMixin} from "@/mixins";
import {enterpriseEngraveApply} from "@/api/EnterpriseSealService";
import {dateFormat} from "@/config/variableConfig";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    // {title: "企业名称", dataIndex: "companyName", key: "companyName", slots: {customRender: "companyName"},width: "150px"},
    // {title: "经办人", dataIndex: "agent", key: "agent"},
    {title: "领取方式", dataIndex: "collectionMethod", key: "collectionMethod", slots: {customRender: "collectionMethod"}},
    {title: "是否为新办市场主体", dataIndex: "isMarket", key: "isMarket", slots: {customRender: "isMarket"}},
    {title: "是否个转企", dataIndex: "isEnterprise", key: "isEnterprise", slots: {customRender: "isEnterprise"}},
    // {title: "邮寄地址", dataIndex: "mailingAddress", key: "mailingAddress",width: "150px"},
    {title: "提交时间", dataIndex: "submitTime", key: "submitTime", slots: {customRender: "submitTime"}},
    {title: "申请进度", dataIndex: "schedule", key: "schedule", slots: {customRender: "schedule"}},
    // {title: "缴税总额", dataIndex: "totalTax", key: "totalTax"},
    {title: "操作", fixed:'right', dataIndex: "action", key: "action", slots: {customRender: "action"},width: "150px"},
];
export default {
    name: "信息补充",
    mixins: [tableListMixin],
    components: {
        Detail,
    },
    data() {
        return {
            dateFormat,
            dictNames: 'isPublic,serviceStatus,condition,demand_type',
            columns,
            queryParam: {},
            listUrl: enterpriseEngraveApply.pageList,
            listKeyField: "id",
            deleteUrl: enterpriseEngraveApply.remove
        }
    },
    methods: {
        onAdd() {
            this.getAction({
            url: companyInfo.detail
            }).then(res => {
            if (res.companyName && res.oraganizationCode && res.detailedAddress && res.corporation) {
                this.$router.push({path: '/sys/EnterpriseSealService/Add'})
            } else {
                this.$message.warning('请完善企业基本信息！')
                this.$router.push({ path: '/sys/companyInfo' })
            }
            })
        },
        onEdit(record) {

            this.$router.push({path: '/sys/EnterpriseSealService/Add', query: {id: record.id}})
            // this.getAction({
            //     url: enterpriseEngraveApply.detail,
            //     params: {id: record.id}
            // }).then(() => {
            //     this.$router.push({path: '/sys/EnterpriseSealService/Add', query: {id: record.id}})
            // })
        },
        onSubmit(record) {
            this.postAction({
                url: enterpriseEngraveApply.submit,
                params: {
                    id: record.id,
                    isSubmit: 1
                }
            }).then(res => {
                if(res){
                    this.loadData();
                }
            })
        },
        onDetail(record){
            this.getAction({
                url: enterpriseEngraveApply.detail,
                params: {id: record.id}
            }).then(res=>{
                this.onShowModal("detailmodal", res)
            })
        },

        exportExcelTemplate0() {
            this.getAction({
                url: enterpriseEngraveApply.querySeal0,
            }).then(res=>{
              const link = document.createElement("a"); // 创建a标签
              link.href =  file_service.download + res;
              link.target = '_blank';
              link.download = decodeURIComponent('刻章刻制流转单模板');// 文件重命名，若无需重命名，将该行删去
              link.click();
            })
        },
        exportExcelTemplate1() {
            this.getAction({
                url: enterpriseEngraveApply.querySeal1,
            }).then(res=>{
              const link = document.createElement("a"); // 创建a标签
              link.href =  file_service.download + res;
              link.target = '_blank';
              link.download = decodeURIComponent('刻章备案登记表模板');// 文件重命名，若无需重命名，将该行删去
              link.click();
            })
        },
        exportExcelTemplate2() {
            this.getAction({
                url: enterpriseEngraveApply.querySeal2,
            }).then(res=>{
              const link = document.createElement("a"); // 创建a标签
              link.href =  file_service.download + res;
              link.target = '_blank';
              link.download = decodeURIComponent('刻章委托书模板');// 文件重命名，若无需重命名，将该行删去
              link.click();
            })
        },
    }
}
</script>

<style scoped>
.clred{
    color:red
}
</style>
